/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConstructionDayReportType } from '../../models/construction-day-report-type';

export interface ApiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost$Params {
  workingEntryId: string;
  reportType: ConstructionDayReportType;
  approve: boolean;
}

export function apiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost(http: HttpClient, rootUrl: string, params: ApiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost.PATH, 'post');
  if (params) {
    rb.path('workingEntryId', params.workingEntryId, {});
    rb.path('reportType', params.reportType, {});
    rb.path('approve', params.approve, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost.PATH = '/api/v0/constructiondayreport/createFromId/{workingEntryId}/{reportType}/{approve}';
